import { assignInlineVars } from '@vanilla-extract/dynamic'
import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'

import { useAppStore } from '@src/app/context'
import type { ActiveCall } from '@src/service/voice'

import * as styles from './IncomingCalls.css'
import { useCallsDialogContext } from './context/useCallsDialogContext'
import { IncomingCall } from './incoming-call'

interface IncomingCallsProps {
  className?: string
}

const IncomingCalls = function ({ className }: IncomingCallsProps) {
  const { service } = useAppStore()
  const { blurred } = useCallsDialogContext()
  const [focusedCall, setFocusedCall] = useState<ActiveCall | null>(null)
  const calls = service.voice.incomingCalls

  useEffect(() => {
    setFocusedCall(calls[calls.length - 1] || null)
  }, [calls])

  return (
    <>
      {calls.map((call, index) => (
        <div
          className={cx(styles.root({ focused: focusedCall === call }), className)}
          tabIndex={-1}
          key={index}
          style={assignInlineVars({ [styles.indexVar]: `${index}` })}
          onClick={() => setFocusedCall(call)}
          role="dialog"
        >
          <IncomingCall call={call} blurred={blurred || focusedCall !== call} />
        </div>
      ))}
    </>
  )
}

export default observer(IncomingCalls)
